import { Input, output } from '@angular/core';
import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from "@angular/router";
import { MatListItem } from "@angular/material/list";
import { MatTooltip } from "@angular/material/tooltip";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'lib-pegase-menu-entry',
  templateUrl: './menu-entry.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    MatListItem,
    MatTooltip,
    MatIcon
  ],
  styleUrls: ['./menu-entry.component.scss'],
  standalone: true,
})
export class MenuEntryComponent {

  /**
   * L'url à ouvrir
   */
  @Input() path!: string;
  /**
   * Titre de l'entrée de menu
   */
  @Input() navTitle!: string;/**

   * Tooltip de l'entrée de menu
   */
  @Input() navTooltip!: string;
  /**
   * Icône material pour l'entrée de menu (facultative)
   */
  @Input() matIcon?: string;
  /**
   * Icône SVG pour l'entrée de menu (facultative)
   */
  @Input() svgIcon?: string;

  @Input() routerLinkActiveOptions?: { exact: boolean }

  @Input() disabled?: boolean = false;
  @Input() displayIf?: boolean = true;

  readonly focusHandler = output<void>();

}
